import { h } from "preact";

import i18n from "../../i18n.js";
import { displayEuro } from "../../salaryHelper.js";
import { classNames, renderHtml } from "../../helpers.js";

export default function MonthlyExpenses({ inApp, result, ...props }) {
  const monthlyNet = Math.round(result.netIncome / 12);

  return (
    <div class={props.class}>
      <p
        class={
          inApp ? "t-h6 color-brand-midnight" : "t-h5 color-brand-midnight"
        }
      >
        {i18n.t("pages.salary_calculator.result.monthly_expenses.title")}
      </p>

      <p
        class={classNames(
          "color-shades-charcoal mb-48",
          inApp ? "t-body3" : "t-body2"
        )}
      >
        {renderHtml(
          i18n.t(
            "pages.salary_calculator.result.monthly_expenses.description",
            { salary: displayEuro(monthlyNet) }
          )
        )}
      </p>

      <div class="salary-calculator-result__display-items">
        <div class="salary-calculator-result__display-item salary-calculator-result__display-item--small">
          <span class="salary-calculator-result__display-item-value">
            {displayEuro(result.expenses.housing / 12)}
          </span>
          <span class="salary-calculator-result__display-item-title">
            {i18n.t("pages.salary_calculator.result.monthly_expenses.housing")}
          </span>
        </div>
        <div class="salary-calculator-result__display-item salary-calculator-result__display-item--small">
          <span class="salary-calculator-result__display-item-value">
            {displayEuro(result.expenses.groceries / 12)}
          </span>
          <span class="salary-calculator-result__display-item-title">
            {i18n.t(
              "pages.salary_calculator.result.monthly_expenses.groceries"
            )}
          </span>
        </div>
        <div class="salary-calculator-result__display-item salary-calculator-result__display-item--small">
          <span class="salary-calculator-result__display-item-value">
            {displayEuro(result.expenses.transportation / 12)}
          </span>
          <span class="salary-calculator-result__display-item-title">
            {i18n.t(
              "pages.salary_calculator.result.monthly_expenses.transportation"
            )}
          </span>
        </div>
        <div class="salary-calculator-result__display-item salary-calculator-result__display-item--small">
          <span class="salary-calculator-result__display-item-value">
            {displayEuro(result.expenses.entertainment / 12)}
          </span>
          <span class="salary-calculator-result__display-item-title">
            {i18n.t(
              "pages.salary_calculator.result.monthly_expenses.entertainment"
            )}
          </span>
        </div>
      </div>
    </div>
  );
}
